module.exports = __webpack_public_path__ + "7b770d6c53423deb1a8e49d3c9175184.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-900italic.woff2
// module id = 677
// module chunks = 0